import { FormInstance } from "antd";
import { SelectList } from "api/baseApiResponseModel/BaseApiResponseModel";
import { isEmpty, isUndefined } from "lodash";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { SimTypeEnum } from "utils/enums/SimTypeEnum";
import {
  TransactionStatusEnum,
  TransactionTypeEnum,
} from "utils/enums/TransactionEnum";
import { getMessage, paramsChecking } from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";

export class DataFormat {
  static transactionStatusOptions(localStrings: typeof strings) {
    return [
      { label: localStrings.GlobalLabels.All, value: "" },
      {
        label: localStrings.AppTransactionHistory.Status.Success,
        value: TransactionStatusEnum.Success,
        color: "green",
      },
      {
        label: localStrings.AppTransactionHistory.Status.Failed,
        value: TransactionStatusEnum.Failed,
        color: "red",
      },
      {
        label: localStrings.AppTransactionHistory.Status.Process,
        value: TransactionStatusEnum.Proccess,
        color: "purple",
      },
      {
        label: localStrings.AppTransactionHistory.Status.Refund,
        value: TransactionStatusEnum.Refund,
        color: "orange",
      },
    ] as SelectList[];
  }

  static transactionTypeOptions(localStrings: typeof strings) {
    return [
      { label: localStrings.GlobalLabels.All, value: "" },
      {
        label: localStrings.AppTransactionHistory.Type.Normal,
        value: TransactionTypeEnum.Normal,
      },
      {
        label: localStrings.AppTransactionHistory.Type.User,
        value: TransactionTypeEnum.User,
      },
      {
        label: localStrings.AppTransactionHistory.Type.Partner,
        value: TransactionTypeEnum.Partner,
      },
    ] as SelectList[];
  }

  static simTypeOptions(localStrings: typeof strings) {
    return [
      { label: localStrings.GlobalLabels.All, value: "" },
      {
        label: localStrings.SimManagement.SimType.Physical,
        value: SimTypeEnum.physical,
      },
      {
        label: localStrings.SimManagement.SimType.ESim,
        value: SimTypeEnum.eSim,
      },
    ] as SelectList[];
  }

  static simNumberTypeOptions(localStrings: typeof strings) {
    return [
      { label: localStrings.GlobalLabels.All, value: "" },
      ...Object.entries(
        localStrings.AppTransactionHistory.Labels.NumberTypeOps
      )?.map(([keys, vals]) => ({
        label: vals,
        value: keys,
      })),
    ];
  }

  static renderItem = (
    label: string,
    value: React.ReactNode,
    color = "black"
  ) => {
    return (
      <div className="flex gap-x-3 justify-between w-full my-2">
        <span className="font-[500] text-[#909090] min-w-[100px]">
          {label}:
        </span>
        <span
          style={{
            color: color,
            fontWeight: color !== "black" ? 500 : "",
            textAlign: "right",
          }}
          className="overflow-visible text-ellipsis"
        >
          {value && value !== "-" && value !== "Invalid Date"
            ? value
            : strings.GlobalLabels.NoInfo}
        </span>
      </div>
    );
  };

  static removeUndefined(obj: Record<string, unknown>) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === undefined) {
        delete obj[key];
      }
    });
    return obj;
  }

  static getToken() {
    return localStorage.getItem("isSavedForNextLogin") === "true"
      ? localStorage.getItem(CacheKeyEnum.mainToken)
      : sessionStorage.getItem(CacheKeyEnum.mainToken);
  }

  static getAlterToken() {
    return sessionStorage.getItem(CacheKeyEnum.alterToken);
  }

  static clickToCopy = async (value: string) =>
    await window?.navigator?.clipboard
      ?.writeText(value)
      .then(() =>
        getMessage(
          `${strings.GlobalMessage.SavedToClipboard} - ${value}`,
          3,
          "success"
        )
      );

  static handleMultipleChange = (
    selected: Array<unknown>,
    filterKey: string,
    form: FormInstance
  ) => {
    console.log(selected);
    if (selected?.includes("") && selected.length > 1) {
      const newValues = isEmpty(selected.at(-1))
        ? [""]
        : selected.filter((item) => item !== "");
      form.setFieldsValue({ [filterKey]: newValues });
    } else if (selected.includes("") && selected.length === 1) {
      form.setFieldsValue({ mySelect: [""] });
    } else if (selected.length === 0) {
      form.setFieldsValue({ [filterKey]: [""] });
    } else {
      form.setFieldsValue({ [filterKey]: selected });
    }
  };

  static getQueryString = (value: Array<string>, key: string) => {
    if (isEmpty(value) || isUndefined(value) || value?.includes("")) {
      return undefined;
    } else {
      value?.forEach((element) => paramsChecking(element, "select"));
      return value
        ?.filter((item) => item !== undefined)
        ?.map((child, index) => `${key}[${index}]=${child}`)
        ?.join("&");
    }
  };

  static removeArrayTypeValue = <T extends Object>(obj: T) => {
    Object?.entries(obj)?.forEach(([keys, vals]) => {
      if (Array.isArray(vals)) {
        delete obj[keys];
      } else {
        return;
      }
    });
    return obj;
  };

  static includeArray = <T extends unknown>(
    firstArr: Array<T>,
    secondArr: Array<T>
  ) => {
    return !isEmpty(firstArr?.filter((child) => secondArr?.includes(child)))
      ? firstArr.filter(
          (child) => !isEmpty(child) && !secondArr?.includes(child)
        )
      : undefined;
  };
}
